<template lang='slm'>
.bz-text.col-12 v-html="localized('html')" :class="customClass"
</template>
<script>
import BzTreeItem from '@/components/mixins/bz-tree-item'

export default {
  name: 'bz-text',
  mixins: [ BzTreeItem ],
  computed: {
    customClass () {
      let textAlign = this.bzData && this.bzData.style && this.bzData.style.textAlign
      let result = ''
      for (let k in textAlign) {
        result = `${result} ${k}-${textAlign[k]}`
      }
      return result
    }
  }
}
</script>
<style lang='scss'>
  @each $header_elem in h1, h2, h3, h4, h5 {
    @each $alignment in center, left, right, justify {
      .bz-text.#{$header_elem}-#{$alignment} > #{$header_elem} {
        text-align: $alignment;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/bz-tree/BzText.vue